import { useState } from "react";
import { columns } from "@/mocks/news";

export default function ColumnsSection() {
  const [active, setActive] = useState(columns[0].id);
  const current = columns.find((c) => c.id === active) || columns[0];

  return (
    <section id="columns" className="scroll-mt-32 mx-auto w-full max-w-7xl px-4 md:px-6 py-12 md:py-16">
      <div className="mb-8 text-center">
        <span className="inline-flex items-center gap-2 text-xs font-medium text-accent-700">
          <i className="ri-grid-fill text-base" aria-hidden="true"></i>
          TOPIC COLUMNS
        </span>
        <h2 className="font-heading mt-2 text-2xl md:text-3xl font-bold text-foreground-950">
          主题分类
        </h2>
        <p className="mt-2 text-sm text-foreground-500">按兴趣直达，只看你想围观的</p>
      </div>

      {/* tab switcher */}
      <div
        role="tablist"
        aria-label="主题分类切换"
        className="mx-auto mb-8 flex w-fit max-w-full flex-wrap items-center justify-center gap-1 rounded-full bg-background-100 p-1"
      >
        {columns.map((c) => (
          <button
            key={c.id}
            role="tab"
            aria-selected={active === c.id}
            onClick={() => setActive(c.id)}
            className={`flex whitespace-nowrap items-center gap-2 rounded-full px-4 py-2.5 text-sm font-medium transition-colors ${
              active === c.id
                ? "bg-background-50 text-primary-700 shadow-none"
                : "text-foreground-500 hover:text-foreground-800"
            }`}
          >
            <i className={`${c.icon} text-base`} aria-hidden="true"></i>
            {c.name}
          </button>
        ))}
      </div>

      {/* active column content */}
      <div key={current.id} className="animate-rise overflow-hidden rounded-2xl border border-background-200 bg-background-100/40">
        <div className={`flex items-center gap-4 px-5 md:px-8 py-6 ${current.bg}`}>
          <span className={`flex h-12 w-12 items-center justify-center rounded-xl bg-background-50 ${current.fg}`}>
            <i className={`${current.icon} text-2xl`} aria-hidden="true"></i>
          </span>
          <div>
            <h3 className={`font-heading text-lg md:text-xl font-bold ${current.fg}`}>{current.name}</h3>
            <p className="text-sm text-foreground-600 mt-0.5">{current.intro}</p>
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 p-5 md:p-8 pt-6">
          {current.posts.map((post, i) => (
            <a
              key={post.title}
              href="#digest"
              className="group flex flex-col rounded-xl border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-300"
            >
              <span className={`font-label mb-3 text-sm ${i === 0 ? "text-primary-500" : "text-foreground-300"}`}>
                {String(i + 1).padStart(2, "0")}
              </span>
              <h4 className="font-heading flex-1 text-base font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-700">
                {post.title}
              </h4>
              <div className="mt-4 flex items-center justify-between text-xs text-foreground-400">
                <span className="inline-flex items-center gap-1.5">
                  <i className="ri-eye-line" aria-hidden="true"></i>
                  {post.reads} 围观
                </span>
                <span className="inline-flex items-center gap-1 whitespace-nowrap text-foreground-400 group-hover:gap-2 group-hover:text-primary-600 transition-all">
                  去围观 <i className="ri-arrow-right-line" aria-hidden="true"></i>
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}